exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".boton-continuar__button{width:100%!important;max-width:unset!important;margin-bottom:0}.boton-continuar__div-centrado{width:100%}@media(min-width:800px){.boton-continuar__button{width:294px!important}.boton-continuar__div-centrado{width:unset;display:table;margin:0 auto;text-align:center}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"minimize":true,"sourceMap":false}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null]}!./src/css/components/BotonContinuar.css
// module id = 436
// module chunks = 0 2 3 4 5 6 7 8 9 10 11 12 13